import axios from "axios";
import util from "@/libs/util";
import { handleApiDecrypt } from "../AesUtil";

const getAuthToken = () => {
	const token = util.cookies.get("Authorization");
	return token === undefined || token === "" ? "" : token.split("Bearer-")[1];
};

const request = axios.create({
	timeout: 60000, // 设置超时时间为18秒
});
request.interceptors.response.use(
	(response) => {
		// 响应成功处理
		if (response.config.url.includes('/extApi')) {
			handleApiDecrypt(response);
		}
		return response; // 返回响应对象
	},
	(error) => {
		return Promise.reject(error);
	}
);
export function serializeParams(params) {
	if (Object.keys(params).length === 0) {
		return {};
	}
	return Object.keys(params)
		.map(
			(key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`,
		)
		.join("&");
}

/**
 * 封装 get 方法，对应 GET 请求
 * @param {string} url 请求url
 * @param {object} params 查询参数
 * @returns {Promise}
 */
export function get(url, params, headers) {
	return new Promise((resolve, reject) => {
		request
			.get(url, {
				params: params,
				headers: {
					...headers,
					// "x-auth-token": getAuthToken(),
				},
			})
			.then((res) => {
				resolve(res.data);
			})
			.catch((err) => {
				reject(err.data);
			});
	});
}

/**
 * 封装 post 方法，对应 POST 请求
 * @param {string} url 请求url
 * @param {object} data 请求体
 * @param {boolean | undefined} info 请求体是否为 FormData 格式
 * @returns {Promise}
 */
export function post(url, data = {}, info) {
	return new Promise((resolve, reject) => {
		let newData = data;
		if (info) {
			// 转formData格式
			newData = new FormData();
			for (let i in data) {
				newData.append(i, data[i]);
			}
		}
		request
			.post(url, newData)
			.then((res) => {
				resolve(res.data);
			})
			.catch((err) => {
				reject(err.data);
			});
	});
}

/**
 * 封装 put 方法，对应 PUT 请求
 * @param {string} url 请求url
 * @param {object} params 请求体
 * @returns {Promise}
 */
export function put(url, params = {}) {
	return new Promise((resolve, reject) => {
		request
			.put(url, params)
			.then((res) => {
				resolve(res.data);
			})
			.catch((err) => {
				reject(err.data);
			});
	});
}

/**
 * 封装 axiosDelete 方法，对应 DELETE 请求
 * @param {string} url 请求url
 * @param {object} params 请求体
 * @returns {Promise}
 */
export function axiosDelete(url, params = {}) {
	return new Promise((resolve, reject) => {
		request
			.delete(url, {
				params: params,
			})
			.then((res) => {
				resolve(res.data);
			})
			.catch((err) => {
				reject(err.data);
			});
	});
}

/**
 * @descripttion: 流文件 api；； 如有流文件，则将流文件与文件名返回，如果没有流文件，返回接口响应
 * @param {*} url 接口地址
 * @param {*} params 接口参数
 * @return {*}
 */
export function postBlob(url, params = {}, isFormData) {
	let data = {};
	if (isFormData) {
		const formData = new FormData();
		for (let key in params) {
			formData.append(key, params[key]);
		}
		data = formData;
	} else {
		data = params;
	}
	return new Promise((resolve, reject) => {
		axios
			.post(url, data, { responseType: "blob" })
			.then((response) => {
				// 获取响应头中的 Content-Disposition 字段
				const contentDisposition = response.headers["content-disposition"];
				if (contentDisposition) {
					// 使用正则表达式提取文件名
					let filename;
					const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
					const matches = filenameRegex.exec(contentDisposition);
					if (matches != null && matches[1]) {
						filename = decodeURIComponent(matches[1].replace(/['"]/g, ""));
					}
					// 将文件名和响应数据一起返回
					resolve({
						filename: filename,
						data: response.data,
					});
				} else {
					resolve(response.data);
				}
			})
			.catch((err) => {
				console.log(err);

				reject(err);
			});
	});
}
